'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'gear';
var width = 512;
var height = 512;
var aliases = [9881,"cog"];
var unicode = 'f013';
var svgPathData = 'M185.9 112.3c-6.5 3.2-12.8 6.8-18.8 10.9-8.2 5.5-18.5 6.9-28 3.8L67.4 103.2 29.5 168.8 86 219.1c7.4 6.6 11.3 16.2 10.7 26.1-.5 7.2-.5 14.6 0 21.8 .7 9.9-3.3 19.5-10.7 26.1l-56.5 50.2 37.9 65.7 71.7-23.8c9.4-3.1 19.7-1.7 28 3.8 6 4 12.3 7.7 18.8 10.9 8.9 4.4 15.2 12.6 17.2 22.3l15.2 74 75.8 0 15.2-74c2-9.7 8.4-17.9 17.2-22.3 6.5-3.2 12.8-6.8 18.8-10.9 8.2-5.5 18.5-6.9 28-3.8l71.7 23.8 37.9-65.7-56.5-50.2c-7.4-6.6-11.3-16.2-10.7-26.1 .2-3.6 .4-7.2 .4-10.9s-.1-7.3-.4-10.9c-.7-9.9 3.3-19.5 10.7-26.1l56.5-50.2-37.9-65.7-71.7 23.8c-9.4 3.1-19.7 1.7-28-3.8-6-4-12.3-7.7-18.8-10.9-8.9-4.4-15.2-12.6-17.2-22.3l-15.2-74-75.8 0-15.2 74c-2 9.7-8.4 17.9-17.2 22.3zM294.2-16c15.2 0 28.3 10.7 31.3 25.5l15.2 74c7.8 3.8 15.4 8.2 22.6 13.1l71.7-23.8c14.4-4.8 30.2 1.2 37.8 14.4l37.9 65.7c7.6 13.2 4.9 29.8-6.5 39.9L447.9 243c.6 8.6 .6 17.5 0 26l56.5 50.2c11.4 10.1 14 26.8 6.5 39.9l-37.9 65.7c-7.6 13.2-23.4 19.2-37.8 14.4l-71.7-23.8c-7.2 4.8-14.7 9.2-22.6 13.1l-15.2 74c-3.1 14.9-16.2 25.5-31.3 25.5l-75.8 0c-15.2 0-28.3-10.7-31.3-25.5l-15.2-74c-7.8-3.8-15.4-8.2-22.6-13.1L77.5 439.2C63.1 444 47.3 438 39.7 424.8L1.8 359.2c-7.6-13.1-4.9-29.8 6.5-39.9L64.7 269c-.6-8.6-.6-17.5 0-26L8.2 192.8c-11.4-10.1-14-26.8-6.5-39.9L39.7 87.2C47.3 74 63.1 68 77.5 72.8l71.7 23.8c7.2-4.8 14.7-9.2 22.6-13.1l15.2-74C190.1-5.3 203.2-16 218.4-16l75.8 0zM200.3 256a55.7 55.7 0 1 0 111.4 0 55.7 55.7 0 1 0 -111.4 0zm55.4 88a88 88 0 1 1 .6-176 88 88 0 1 1 -.6 176z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGear = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;